// React router that changes between home, workbook and createbonsai
import React, { Fragment, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
// import { bonsai } from "../libs/fakeDesignData";
import { getClients } from "../../libs/toggl/getClients";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import { getLastTimeSeenClient } from "../../libs/toggl/getLastTimeSeenClient";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import AppBarResourceList from "../../components/AppBar/ResourceList";
import AppBarPlanner from "../../components/AppBar/Planner";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import { uploadDataWithName } from "../../libs/firebase/firestore/uploadDataWithName";
import { getData } from "../../libs/firebase/firestore/getData";
import AppBarTasks from "../../components/AppBar/Tasks";
import { updateData } from "../../libs/firebase/firestore/updateData";
import { uploadData } from "../../libs/firebase/firestore/uploadData";
import { Delete, Park } from "@mui/icons-material";
import { deleteData } from "../../libs/firebase/firestore/deleteData";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import TaskListScheduleDialog from "../../components/TaskList/ScheduleDialog";
import { TaskListScheduledDay } from "../../components/TaskList/ScheduledDay";
import TaskListWeekCalendar from "../../components/TaskList/WeekCalendar";
import { sortByDayString } from "../../utilities/sortByDayString";
function getIcon(task) {
  // if task includes "planting" then return plant icon
  if (task.toLowerCase().includes("planting")) {
    return <Park />;
  }

  // if plants then return plant icon
  if (task.toLowerCase().includes("plants")) {
    return <Park />;
  }

  // if garden then return design icon
  if (task.toLowerCase().includes("garden")) {
    return <DesignServicesIcon />;
  }
}

export function TaskBriefSummary({ task, ...props }) {
  // concat the client name if has last name and first name
  let clientName = task.clientName;
  // check if there is a space in the client name
  if (clientName.includes(" ")) {
    // split the client name by space
    let splitClientName = clientName.split(" ");

    let firstName = splitClientName[0];
    let lastName = splitClientName[1];

    // if first name longer than 8 characters then concat to first 7 and add period
    if (firstName.length > 8) {
      firstName = `${firstName.substring(0, 5)}.`;
    }

    // Change the last name to first initial and period
    lastName = `${lastName[0]}.`;

    clientName = `${firstName} ${lastName}`;
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      style={{
        alignItems: "center",
      }}
      {...props}
    >
      <Chip icon={getIcon(task.description)} label={clientName} />
      <Typography>{task.description}</Typography>
      <div style={{ flexGrow: 1 }} />
    </Stack>
  );
}

export function TaskBrief({ task, onCheck, onDelete, onClick, ...props }) {
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const handleOnClick = () => {
    onClick(task);
  };

  // concat the client name if has last name and first name
  let clientName = task.clientName;
  // check if there is a space in the client name
  if (clientName.includes(" ")) {
    // split the client name by space
    let splitClientName = clientName.split(" ");

    let firstName = splitClientName[0];
    let lastName = splitClientName[1];

    // if first name longer than 8 characters then concat to first 7 and add period
    if (firstName.length > 8) {
      firstName = `${firstName.substring(0, 5)}.`;
    }

    // Change the last name to first initial and period
    lastName = `${lastName[0]}.`;

    clientName = `${firstName} ${lastName}`;
  }

  return (
    <Fragment>
      {/* Dialog ask if delete */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => {
          setOpenDeleteDialog(false);
        }}
      >
        <DialogContent>
          <Typography>Are you sure you want to delete this task?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDeleteDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setOpenDeleteDialog(false);
              onDelete(task);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Stack
        direction="row"
        spacing={2}
        style={{
          alignItems: "center",
        }}
        {...props}
      >
        {/* <Typography>{client.id}</Typography> */}
        <input
          type="checkbox"
          checked={task.complete}
          onChange={(e) => onCheck(task, e.target.checked)}
        />
        <TaskListScheduledDay day={task.scheduledDay} />
        <Chip
          onClick={handleOnClick}
          icon={getIcon(task.description)}
          label={clientName}
        />
        <Typography onClick={handleOnClick}>{task.description}</Typography>
        <div style={{ flexGrow: 1 }} />
        {/* Delete icon */}
        <IconButton
          onClick={() => {
            setOpenDeleteDialog(true);
          }}
        >
          <Delete />
        </IconButton>
      </Stack>
    </Fragment>
  );
}

function ScreenPlannerTasks() {
  const navigate = useNavigateToTop();

  // state for schedule dialog
  const [openScheduleDialog, setOpenScheduleDialog] = React.useState(false);

  // state to hold clients
  const [clients, setClients] = React.useState([]);

  // state to hold clients
  const [tasks, setTasks] = React.useState([]);

  // state to hold last task click
  const [lastTaskClick, setLastTaskClick] = React.useState(null);

  useEffect(() => {
    // get clients from toggl
    getAllData("tasks", (tasks) => {
      setTasks(tasks);
    });
    getAllData("clients", (clients) => {
      setClients(clients);
    });
  }, []);

  const handleOnCheck = (task, checked) => {
    // update the task on firebase
    updateData(
      {
        complete: checked,
      },
      `tasks`,
      task.storageDocumentId,
      () => {
        // update the task in the state
        let newTasks = [...tasks];
        let index = newTasks.findIndex(
          (item) => item.storageDocumentId === task.storageDocumentId
        );
        newTasks[index].complete = checked;
        setTasks(newTasks);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleAddTask = (task) => {
    // upload the task to firebase
    uploadData(
      task,
      "tasks",
      () => {
        // add the task to the state
        // let newTasks = [...tasks];
        // newTasks.push(task);
        // setTasks(newTasks);

        getAllData("tasks", (tasks) => {
          setTasks(tasks);
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleOnDelete = (task) => {
    deleteData(
      "tasks",
      task.storageDocumentId,
      () => {
        // delete the task from the state
        let newTasks = [...tasks];
        let index = newTasks.findIndex(
          (item) => item.storageDocumentId === task.storageDocumentId
        );
        newTasks.splice(index, 1);
        setTasks(newTasks);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  // Sort tasks by clientName
  tasks.sort((a, b) => {
    if (a.clientName < b.clientName) {
      return -1;
    }
    if (a.clientName > b.clientName) {
      return 1;
    }
    return 0;
  });

  // now sort by scheduledDay then by clientName

  const handleTaskClick = (task) => {
    setLastTaskClick(task);
    setOpenScheduleDialog(true);
  };

  const handleScheduleClick = (dayOfWeek) => {
    // update the task on firebase
    let request = {
      scheduledDay: dayOfWeek,
    };
    updateData(
      request,
      `tasks`,
      lastTaskClick.storageDocumentId,
      () => {
        // update the task in the state
        let newTasks = [...tasks];
        let index = newTasks.findIndex(
          (item) => item.storageDocumentId === lastTaskClick.storageDocumentId
        );
        newTasks[index].scheduledDay = dayOfWeek;
        setTasks(newTasks);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  // completed tasks
  let completedTasks = tasks.filter((task) => {
    return task.complete;
  });

  // incomplete tasks
  let incompleteTasks = tasks.filter((task) => {
    return (
      (!task.complete && task.scheduledDay == "") ||
      task.scheduledDay == null ||
      task.scheduledDay == undefined
    );
  });

  // Schedule tasks
  let scheduledTasks = tasks.filter((task) => {
    return (
      task.scheduledDay != "" &&
      task.scheduledDay != null &&
      task.scheduledDay != undefined
    );
  });

  // Sort scheduled tasks by scheduledDay where schedule day is a string
  scheduledTasks = sortByDayString(scheduledTasks, "scheduledDay");

  return (
    <Box>
      <AppBarTasks onAddTask={handleAddTask} clients={clients} />

      <TaskListScheduleDialog
        open={openScheduleDialog}
        onClose={() => {
          setOpenScheduleDialog(false);
        }}
        onClick={(day) => {
          handleScheduleClick(day);
          setOpenScheduleDialog(false);
        }}
      />
      <TaskListWeekCalendar tasks={tasks} onClick={handleTaskClick} />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Tasks</Typography>
        <Typography variant="subtitle1">These are the current tasks</Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />
        <Stack direction="column" spacing={2}>
          {incompleteTasks.map((task, index) => {
            return (
              <TaskBrief
                key={index}
                task={task}
                onCheck={handleOnCheck}
                onDelete={handleOnDelete}
                onClick={handleTaskClick}
              />
            );
          })}
        </Stack>
        <Divider
          sx={{
            my: 2,
          }}
        />
        <Typography variant="h5">Scheduled Tasks</Typography>
        <Stack direction="column" spacing={2}>
          {scheduledTasks.map((task, index) => {
            return (
              <TaskBrief
                key={index}
                task={task}
                onCheck={handleOnCheck}
                onDelete={handleOnDelete}
                onClick={handleTaskClick}
              />
            );
          })}
        </Stack>

        <Typography variant="h5">Completed Tasks</Typography>
        <Stack direction="column" spacing={2}>
          {completedTasks.map((task, index) => {
            return (
              <TaskBrief
                key={index}
                task={task}
                onCheck={handleOnCheck}
                onDelete={handleOnDelete}
                onClick={handleTaskClick}
              />
            );
          })}
        </Stack>

        {/* <ResourceListsTable
          onClick={(resourceList) => {
            navigate(`/resource-list/${resourceList.storageDocumentId}`);
          }}
          // onDelete={handleOnDelete}
          data={resourceLists}
        /> */}
      </Box>
    </Box>
    // <Routes>
    //   <Route path="/">
    //     {/* <Route index element={<ScreenCreateResourceLists />} /> */}
    //   </Route>
    // </Routes>
  );
}

export default ScreenPlannerTasks;
